
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1Q21q", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $luv00 = parcelRequire("luv00");

const $4ead1b0c84785c64$export$81ac9ce93f56b5bb = (props)=>{
    const $ = (0, $frIzR.c)(11);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let children;
    let dataVC;
    let restProps;
    if ($[0] !== props) {
        ({ children: children, dataVC: dataVC, ...restProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = dataVC;
        $[3] = restProps;
    } else {
        children = $[1];
        dataVC = $[2];
        restProps = $[3];
    }
    let t0;
    if ($[4] !== children || $[5] !== dataVC || $[6] !== ssrPlaceholderIdProp) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": dataVC,
            ...ssrPlaceholderIdProp
        }, children);
        $[4] = children;
        $[5] = dataVC;
        $[6] = ssrPlaceholderIdProp;
        $[7] = t0;
    } else t0 = $[7];
    let t1;
    if ($[8] !== restProps || $[9] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...restProps,
            "data-vc": "uK6KTknI"
        }, t0);
        $[8] = restProps;
        $[9] = t0;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
};
module.exports["EngagementInlineDialogWrapper"] = $4ead1b0c84785c64$export$81ac9ce93f56b5bb;

});


//# sourceMappingURL=EngagementInlineDialogWrapper.7c3572a6.js.map
